import { gql, useApolloClient } from '@apollo/client';

const STREAM_SET_WITH_THEMATIC_CONTENT_QUERY = gql`
  query streamSetWithThematicContent @client {
    withThematic
  }
`;

export type UseStreamWithThematicType = {
  readStreamWithThematic: () => boolean;
  setStreamWithThematic: (withThematic: boolean) => boolean;
  clearStreamWithThematic: () => void;
};

const useStreamWithThematic = (): UseStreamWithThematicType => {
  const client = useApolloClient();

  const clearStreamWithThematic = () => {
    client.cache.evict({
      id: 'ROOT_QUERY',
      fieldName: 'withThematic',
    });

    client.cache.gc();
  };

  const readStreamWithThematic = () => {
    const withThematic = client.readQuery<{ withThematic: boolean }>({
      query: STREAM_SET_WITH_THEMATIC_CONTENT_QUERY,
    });

    return withThematic?.withThematic ?? false;
  };

  const setStreamWithThematic = (withThematic: boolean) => {
    clearStreamWithThematic();

    const thematic = client.writeQuery({
      query: STREAM_SET_WITH_THEMATIC_CONTENT_QUERY,
      data: { withThematic },
    });

    return !!thematic;
  };

  return { readStreamWithThematic, setStreamWithThematic, clearStreamWithThematic };
};

export default useStreamWithThematic;
